<template>
  <div>
    <div>
      <div class="c-card-body">
        <datatable
          ref="datatable"
          module="package"
          :title="title"
          :url="url"
          :filter="filter"
          :columns="columns"
          :on-click-create="onClickCreate"
          :on-click-update="onClickUpdate"
          :on-click-delete="onClickDelete"
          :action-width="180"
        >
        <template v-slot:action>
          <v-col md="3">
            <v-select
              label="Status"
              dense
              outlined
              v-model="filterIsActive"
              :items="listIsActive"
              item-text="name"
              item-value="id"
              hide-details="true"
              clearable
            />
          </v-col>
        </template>
        <template v-slot:[`item.price_bottom`]="{ item }">
          <div>
            Rp {{ new Intl.NumberFormat("id-ID").format(item.price_bottom) }}
          </div>          
        </template>
        <template v-slot:[`item.price_sales`]="{ item }">
          <div>
            Rp {{ new Intl.NumberFormat("id-ID").format(item.price_sales) }}
          </div>          
        </template>
        <template v-slot:[`item.is_monthly`]="{ item }">
          <div style="width: 55px; text-align: center">
            <v-icon
              v-if="item.is_monthly"
              :color="'#4CAF50'"
              small
              :text-color="'white'"
            >
              mdi-checkbox-marked-circle
            </v-icon>
            <v-icon
              v-if="!item.is_monthly"
              :color="'#C62828'"
              small
              :text-color="'white'"
            >
              mdi-minus-circle
            </v-icon>
          </div>
        </template>
        <template v-slot:[`item.is_session`]="{ item }">
          <div style="width: 55px; text-align: center">
            <v-icon
              v-if="item.is_session"
              :color="'#4CAF50'"
              small
              :text-color="'white'"
            >
              mdi-checkbox-marked-circle
            </v-icon>
            <v-icon
              v-if="!item.is_session"
              :color="'#C62828'"
              small
              :text-color="'white'"
            >
              mdi-minus-circle
            </v-icon>
          </div>
        </template>
        <template v-slot:[`item.is_class`]="{ item }">
          <div style="width: 55px; text-align: center">
            <v-icon
              v-if="item.is_class"
              :color="'#4CAF50'"
              small
              :text-color="'white'"
            >
              mdi-checkbox-marked-circle
            </v-icon>
            <v-icon
              v-if="!item.is_class"
              :color="'#C62828'"
              small
              :text-color="'white'"
            >
              mdi-minus-circle
            </v-icon>
          </div>
        </template>
        <template v-slot:[`item.is_active`]="{ item }">
          <div style="width: 55px; text-align: center">
            <v-icon
              v-if="item.is_active"
              :color="'#4CAF50'"
              small
              :text-color="'white'"
            >
              mdi-checkbox-marked-circle
            </v-icon>
            <v-icon
              v-if="!item.is_active"
              :color="'#C62828'"
              small
              :text-color="'white'"
            >
              mdi-minus-circle
            </v-icon>
          </div>
        </template>

      </datatable>
      </div>
    </div>
    <form-data ref="form" module="package" :success="formSuccess" />
    <delete-dialog
      ref="delete"
      url="package"
      :success="deleteSuccess"
    ></delete-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import FormData from "./Form";

export default {
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Manajemen Paket", route: "" },
      { title: "Paket" }
    ]);
  },
  data() {
    return {
      title: "Paket",
      url: "package/data",
      filter: null,
      filterIsActive: null,
      listIsActive: [
        { id: true, name: "Aktif" },
        { id: false, name: "Tidak Aktif" }
      ],
      columns: [
        {
          value: "id"
        },
        {
          text: "Nama Paket",
          value: "name",
          sortable: true,
          searchable: true
        },
        {
          text: "Harga Bottom",
          value: "price_bottom",
          sortable: true,
          searchable: false
        },
        {
          text: "Harga Sales",
          value: "price_sales",
          sortable: true,
          searchable: false
        },
        {
          text: "Paket Bulanan",
          value: "is_monthly",
          sortable: false,
          searchable: false,
        },
        {
          text:"Paket Sesi",
          value: "is_session",
          sortable: false,
          searchable: false,
        },
        {
          text: "Paket Kelas",
          value: "is_class",
          sortable: false,
          searchable: false,
        },
        {
          text: "Durasi (Bulan)",
          value: "duration_month",
          sortable: false,
          searchable: false,
        },
        {
          text: "Jumlah Sesi",
          value: "session_count",
          sortable: false,
          searchable: false,
        },
        {
          text: "Status",
          value: "is_active",
          sortable: false,
          searchable: false,
        },

      ]
    };
  },
  methods: {
    filterBy() {
      const finalFilter = [];

      if (this.filterIsActive !== null) {
        finalFilter.push({
          column: "is_active",
          value: this.filterIsActive
        });
      }

      this.filter = finalFilter.length > 0 ? finalFilter : null;
    },
    onClickCreate() {
      this.$refs.form.open();
    },
    onClickUpdate(item) {
      this.$refs.form.open(item.id);
    },
    onClickDelete(item) {
      this.$refs.delete.open(item.id);
    },
    formSuccess() {
      this.$refs.datatable.getData();
    },
    deleteSuccess() {
      this.$refs.datatable.getData();
    },
    formattedPrice() {
      return new Intl.NumberFormat("id-ID").format(this.harga);
    }
  },
  watch: {
    filterIsActive() {
      this.filterBy();
    }
  },
  components: {
    Datatable,
    DeleteDialog,
    FormData
  }
};
</script>
